import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countryCode", "postalCode", "payButton", "taxId"]

  static values = { valid: Boolean }

  validate() {
    if (this.countryCodeTarget.value === "") {
      return
    }

    console.debug("Validating address for country: " + this.countryCodeTarget.value)

    // US postal code validation.
    if (this.countryCodeTarget.value === "US") {
      this.validateUSPostalCode()
      return
    }

    // India GSTIN validation.
    if (this.countryCodeTarget.value === "IN") {
      this.validateIndiaGSTIN()
      return
    }

    this.removeWarning()
  }

  validateUSPostalCode() {
    this.postalCodeTarget.value = this.postalCodeTarget.value.trim()

    // A US postal code should have the format 12345 or 12345-6789.
    if (this.postalCodeTarget.value === "" || this.postalCodeTarget.value.match(/^[0-9]{5}(?:-[0-9]{4})?$/) === null) {
      this.validValue = false
      this.postalCodeTarget.style.border = "1px solid red"
      this.payButtonTarget.classList.add("disabled")

      App.displayFlash("danger", "Your ZIP code doesn't seem valid")
    } else {
      this.removeWarning()
    }
  }

  validateIndiaGSTIN() {
    this.taxIdTarget.value = this.taxIdTarget.value.trim()
    this.taxIdTarget.value = this.taxIdTarget.value.toUpperCase()

    var _this = this

    let headers = {}

    if (document.querySelector("meta[name='csrf-token']")) {
      headers["X-CSRF-Token"] = document.querySelector("meta[name='csrf-token']").content
    }

    fetch(`/internal/tax_id_validations?gstin=${this.taxIdTarget.value}`, {
      method: "POST",
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.valid) {
          console.info(`Supplied GSTIN (${this.taxIdTarget.value}) is valid`)
          _this.removeWarning()
          return
        }

        console.warn(`Supplied GSTIN (${this.taxIdTarget.value}) is invalid`)

        this.validValue = false
        this.taxIdTarget.style.border = "1px solid red"
        this.payButtonTarget.classList.add("disabled")
      })
  }

  removeWarning() {
    // It is important to only change the interface if we know we already showed
    // to the user a warning. Otherwise, we might for example remove the
    // disabled class of the checkout button by mistake.
    if (this.validValue) {
      return
    }

    App.hideFlash()

    this.payButtonTarget.classList.remove("disabled")
    this.taxIdTarget.style.border = ""
    this.postalCodeTarget.style.border = ""
    this.validValue = true
  }
}
